import { LoyaltyProgramCategory } from './loyalty-program.type';

export enum MembershipType {
  PointsTransfer = 'points_transfer_membership',
  CashBack = 'cashback_membership',
}

export interface PointsTransferMembership {
  id: string;
  type: MembershipType.PointsTransfer;
  category:
    | LoyaltyProgramCategory.Airline
    | LoyaltyProgramCategory.Hotel
    | LoyaltyProgramCategory.Voucher
    | LoyaltyProgramCategory.Retail
    | LoyaltyProgramCategory.Others;
  firstName: string | null;
  lastName: string | null;
  loyaltyProgramId: string;
  loyaltyProgramName: string;
  number: string;
  preferred: boolean;
  userId: string;
  dateOfBirth?: string;
}

export interface CashBackToCardMembership {
  id: string;
  type: MembershipType.CashBack;
  category: LoyaltyProgramCategory.CashbackToCard;
  userId: string;
  loyaltyProgramId: string;
  loyaltyProgramName: string;
  number: string;
  firstName: string | null;
  lastName: string | null;
  fullName: string | null;
  preferred: boolean;
  enrollmentId: string;
  enrollment: {
    id: string;
    groupName: string;
    status: 'active' | 'closed' | 'blocked' | 'write_off';
    productCategory?: string;
    productCode?: string;
  };
  details: {
    groupName: string;
  };
}

export interface CashBackToPlatformMembership {
  id: string;
  type: MembershipType.CashBack;
  category: LoyaltyProgramCategory.CashbackToPlatform;
  userId: string;
  loyaltyProgramId: string;
  loyaltyProgramName: string;
  number: string;
  firstName: string | null;
  lastName: string | null;
  fullName: string | null;
  preferred: boolean;
  enrollmentId: null;
  enrollment: null;
}

export interface CashBackToAccountMembership {
  id: string;
  type: MembershipType.CashBack;
  category: LoyaltyProgramCategory.CashbackToAccount;
  userId: string;
  loyaltyProgramId: string;
  loyaltyProgramName: string;
  number: string;
  firstName: string | null;
  lastName: string | null;
  fullName: string | null;
  preferred: boolean;
  enrollmentId: null;
  enrollment: null;
  details: {
    bsbNumber: string;
  };
}

export type CashBackMembership =
  | CashBackToCardMembership
  | CashBackToAccountMembership
  | CashBackToPlatformMembership;

export type Membership = CashBackMembership | PointsTransferMembership;
